
import { 
  Dialog, 
  DialogContent, 
  DialogDescription, 
  DialogHeader, 
  DialogTitle 
} from '@/components/ui/dialog';
import { Assessment } from '@/types/assessment';
import { useAssessmentInvitation } from '@/hooks/useAssessmentInvitation';
import { InviteToAssessmentForm } from './InviteToAssessmentForm';

interface InviteToAssessmentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUserInvited: () => void;
  assessment: Assessment;
}

export function InviteToAssessmentDialog({ 
  open, 
  onOpenChange, 
  onUserInvited, 
  assessment 
}: InviteToAssessmentDialogProps) {
  const {
    email,
    setEmail,
    fullName,
    setFullName,
    selectedOrganizationId,
    setSelectedOrganizationId,
    organizations,
    loading,
    error,
    handleSubmit
  } = useAssessmentInvitation({
    open,
    assessment,
    onUserInvited,
    onOpenChange
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Invite User to Assessment</DialogTitle>
          <DialogDescription>
            Invite a user to take the assessment "{assessment.title}". They will receive an email with direct access to the assessment and organization setup instructions.
          </DialogDescription>
        </DialogHeader>
        
        <InviteToAssessmentForm
          email={email}
          setEmail={setEmail}
          fullName={fullName}
          setFullName={setFullName}
          selectedOrganizationId={selectedOrganizationId}
          setSelectedOrganizationId={setSelectedOrganizationId}
          organizations={organizations}
          loading={loading}
          error={error}
          assessment={assessment}
          onSubmit={handleSubmit}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
